import { render, staticRenderFns } from "./battleCaseDetail.vue?vue&type=template&id=55dc3956&scoped=true&"
import script from "./battleCaseDetail.vue?vue&type=script&lang=js&"
export * from "./battleCaseDetail.vue?vue&type=script&lang=js&"
import style0 from "./battleCaseDetail.vue?vue&type=style&index=0&id=55dc3956&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55dc3956",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('55dc3956')) {
      api.createRecord('55dc3956', component.options)
    } else {
      api.reload('55dc3956', component.options)
    }
    module.hot.accept("./battleCaseDetail.vue?vue&type=template&id=55dc3956&scoped=true&", function () {
      api.rerender('55dc3956', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/multiplePeopleCase/components/battleCaseDetail.vue"
export default component.exports